import React, { useState } from "react";
import Megaphone from "../../assets/image/megaphone.png";

function Scholarship() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <>
      <div className="container my-5 ">
        <div className="scholarship-banner d-flex align-items-center ">
          <img src={Megaphone} alt="Megaphone" className="megaphone" />
          <div className="text-content ">
            <h3>100% scholarship for up to 100 students</h3>
            <p>
              We are giving away 100% scholarship for upto 100 beginner students
              to help them get started with their Coding journey with
              datacode.in
            </p>
          </div>
          <button type="button" className="close" aria-label="Close" onClick={() => setVisible(false)}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </>
  );
}

export default Scholarship;
